import StatusTrackerErrorContainer from './StatusTrackerErrorContainer';

export default StatusTrackerErrorContainer;



// WEBPACK FOOTER //
// ./src/components/pages/StatusTrackerError/index.js